import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"delete\">\n  <path d=\"M17 30.087c0 .54.453.993 1.003.993h7.994A.997.997 0 0 0 27 30.087V19H17v11.087zM20 15h-2v-.998A2.999 2.999 0 0 1 21.002 11h1.996A2.999 2.999 0 0 1 26 14.002V15h-6 4v-.998A.999.999 0 0 0 22.998 13h-1.996A.999.999 0 0 0 20 14.002V15zm9 4v11.087a2.997 2.997 0 0 1-3.003 2.993h-7.994A3.006 3.006 0 0 1 15 30.087V19h14zm-16-3h18v2H13v-2zm10 4v9h1v-9h-1zm-3 0v9h1v-9h-1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol